import React, { useEffect, useState } from 'react';
import Sidebar from './sidebar/Sidebar';
import Header from './Header/Header';
import { useDispatch, useSelector } from 'react-redux';
import { setTheme } from '../app-container/reducer/themeSlice';
import useLoader from '../../hooks/useLoader';
import Loader from '../../components/common/Loader/Loader';

const Layout = ({ ChildComponent, ...props }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const dispatch = useDispatch();
  const isDark = useSelector((state) => state.theme.isDark);
  const { loading, startLoading, stopLoading } = useLoader();

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      dispatch(setTheme({ isDark: savedTheme === 'dark' }));
    }
  }, [dispatch]);

  useEffect(() => {
    document.documentElement.setAttribute(
      'data-theme',
      // isDark ? 'light' : 'dark'
      isDark ? 'light' : 'light'
    );
  }, [isDark]);

  const handleThemeToggle = () => {
    const newTheme = isDark ? 'light' : 'light';
    dispatch(setTheme({ isDark: !isDark }));
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />
      <main className={`dashboard-main ${isSidebarOpen ? 'active' : ''}`}>
        <Header
          onSidebarToggle={handleSidebarToggle}
          onThemeToggle={handleThemeToggle}
        />
        <div className="dashboard-main-body">
          <ChildComponent {...props} />
        </div>
      </main>
    </>
  );
};

export default Layout;
